import React from "react";
var __jsx = React.createElement;
import Markdown from "markdown-to-jsx";
import { motion } from "framer-motion";
import { Icon } from "@syarahtech/ui";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import { sectionToPurchaseMethod } from "./utils";
import RadioDot from "./RadioDot";
import BadgePill from "./BadgePill";
import CornerRibbon from "./CornerRibbon";
import InfoIconButton from "./InfoIconButton";
import PrecheckoutCampaignLabel from "@/components/MarketingThemeLabels/PrecheckoutCampaignLabel";
var sectionToCampaignType = function sectionToCampaignType(methodType) {
  if (methodType === "cash") return "cash";
  if (methodType === "free_finance" || methodType === "arib_finance") return "finance";
  return null;
};
export default function PaymentSectionCard(_ref) {
  var section = _ref.section,
    selectedSplitPaymentUrl = _ref.selectedSplitPaymentUrl,
    onSplitPaymentSelected = _ref.onSplitPaymentSelected,
    onInfoClick = _ref.onInfoClick,
    onCampaignClick = _ref.onCampaignClick;
  var purchaseMethod = useCheckoutOrder().state.purchaseMethod;
  var action__setPurchaseMethod = useCheckoutOrder().actions.action__setPurchaseMethod;
  var purchaseMethodValue = sectionToPurchaseMethod(section.method_type);
  var isSplitPayment = section.method_type === "split_payment";
  var disabled = section.state.enabled === false;
  var isSelected = isSplitPayment ? !!selectedSplitPaymentUrl : !!purchaseMethodValue && purchaseMethod === purchaseMethodValue;
  var campaignType = sectionToCampaignType(section.method_type);
  var campaign = section.campaign;
  var handleClick = function handleClick() {
    var _section$action;
    if (disabled) return;
    if (isSplitPayment && (_section$action = section.action) !== null && _section$action !== void 0 && _section$action.url) {
      action__setPurchaseMethod(null);
      onSplitPaymentSelected(section.action.url);
    } else if (purchaseMethodValue) {
      action__setPurchaseMethod(purchaseMethodValue);
      onSplitPaymentSelected(null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: ["relative overflow-hidden rounded-lg border border-solid transition-colors", isSelected ? "border-primary-new bg-[#f1f6fc]" : "border-[#e0e0e0] bg-white", disabled && "opacity-40 pointer-events-none"].filter(Boolean).join(" ")
  }, /*#__PURE__*/React.createElement(motion.button, {
    type: "button",
    disabled: disabled,
    onClick: handleClick,
    whileTap: disabled ? undefined : {
      scale: 0.985
    },
    transition: {
      type: "spring",
      stiffness: 400,
      damping: 25
    },
    className: ["relative flex w-full items-center gap-3 py-[19px] px-4", disabled ? "cursor-not-allowed" : "cursor-pointer hover:bg-[#f1f6fc]"].join(" ")
  }, disabled ? /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--lock-outline",
    className: "shrink-0 text-[#b0b0b0]",
    width: 5,
    height: 5
  }) : /*#__PURE__*/React.createElement(RadioDot, {
    selected: isSelected
  }), section.ribbon && /*#__PURE__*/React.createElement(CornerRibbon, {
    ribbon: section.ribbon
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex min-w-0 flex-1 flex-col gap-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement("p", {
    className: "flex-1 text-start text-sm font-bold leading-5 [&_strong]:font-bold ".concat(disabled ? "text-[#b0b0b0]" : "text-[#00143c]")
  }, /*#__PURE__*/React.createElement(Markdown, {
    className: "me-1"
  }, section.title), section.info && /*#__PURE__*/React.createElement(InfoIconButton, {
    action: section.info.action,
    onOpen: onInfoClick
  }))), section.sub_title && /*#__PURE__*/React.createElement("p", {
    className: "text-start text-xs leading-4 [&_strong]:font-bold ".concat(disabled ? "text-[#b0b0b0]" : "text-[#6b7ea5]")
  }, /*#__PURE__*/React.createElement(Markdown, null, section.sub_title))), section.badge && /*#__PURE__*/React.createElement(BadgePill, {
    badge: section.badge
  })), campaign && campaignType && /*#__PURE__*/React.createElement(PrecheckoutCampaignLabel, {
    data: {
      text: campaign.lable,
      type: campaignType,
      icon: campaign.icon,
      bgColor: campaign.bg_color,
      txtColor: campaign.txt_color
    },
    type: campaignType,
    onLearnClick: function onLearnClick() {
      return onCampaignClick === null || onCampaignClick === void 0 ? void 0 : onCampaignClick(campaign, campaignType);
    }
  }));
}